"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const React = require("react");
const ReactDOM = require("react-dom");
const NavBar_1 = require("./NavBar");
const colors_1 = require("../styles/colors");
const react_popper_1 = require("react-popper");
const ResponsiveContainer_1 = require("../components/ResponsiveContainer");
class PopoverComponent extends React.Component {
    constructor(props) {
        super(props);
        this.scheduleUpdate = undefined;
        this.handleClickOutside = this.handleClickOutside.bind(this);
        this.evalChild = this.evalChild.bind(this);
        this.getElement = this.getElement.bind(this);
        this.handleKeyPress = this.handleKeyPress.bind(this);
    }
    componentDidMount() {
        document.addEventListener('mouseup', this.handleClickOutside);
        document.addEventListener('keydown', this.handleKeyPress, false);
        document.addEventListener('touchend', this.handleClickOutside);
    }
    componentWillUnmount() {
        document.removeEventListener('mouseup', this.handleClickOutside);
        document.removeEventListener('keydown', this.handleKeyPress, false);
        document.removeEventListener('touchend', this.handleClickOutside);
    }
    componentDidUpdate() {
        if (this.props.forceUpdate) {
            this.scheduleUpdate();
        }
    }
    handleKeyPress(e) {
        if (this.props.toggleable) {
            if (e.keyCode === 27) {
                this.props.toggle();
            }
        }
    }
    getElement(placement, navBarHeight) {
        if (document.getElementById('popoverCustomStyle')) {
            let elem = document.getElementById('popoverCustomStyle');
            elem.parentNode.removeChild(elem);
        }
        let arrowPosition = document.querySelector('div.popper__arrow').style.top;
        let styleElem = document.head.appendChild(document.createElement('style'));
        styleElem.setAttribute('id', 'popoverCustomStyle');
        const { primary, secondary, border } = this.props.arrowColors;
        if (placement === 'left' || placement === 'right') {
            if (parseInt(navBarHeight, 10) > parseInt(arrowPosition, 10)) {
                styleElem.innerHTML = `
                .popper[data-placement^='right'] .popper__arrow {
                    background: ${primary} !important; 
                }
                .popper[data-placement^='left'] .popper__arrow {
                    background: ${primary} !important; 
                }
                `;
            }
            else {
                styleElem.innerHTML = `
                .popper[data-placement^='right'] .popper__arrow {
                    background: ${secondary} !important; 
                }
                .popper[data-placement^='left'] .popper__arrow {
                    background: ${secondary} !important; 
                }
                `;
            }
        }
        else if (placement === 'bottom') {
            styleElem.innerHTML = `.popper[data-placement^='bottom'] .popper__arrow {
                background: ${primary} !important; 
            }`;
        }
        else if (placement === 'top') {
            styleElem.innerHTML = `.popper[data-placement^='top'] .popper__arrow {
                background: ${secondary} !important; 
            }`;
        }
    }
    evalChild() {
        const Fragment = React.Fragment;
        let val;
        if (this.props.navBarProperties !== undefined) {
            val = (React.createElement(Fragment, null, this.props.navBarProperties !== undefined && (React.createElement(NavBar_1.default, Object.assign({}, this.props.navBarProperties, { getElement: this.getElement })))));
        }
        else {
            const { primary } = this.props.arrowColors;
            if (document.getElementById('popoverCustomStyle')) {
                let elem = document.getElementById('popoverCustomStyle');
                elem.parentNode.removeChild(elem);
            }
            val = (React.createElement(Fragment, null,
                React.createElement("style", { type: "text/css" }, `
                            .popper[data-placement^='top'] .popper__arrow {
                                background: ${primary}; !important;
                            }
                            .popper[data-placement^='bottom'] .popper__arrow {
                                background: ${primary}; !important;
                            }
                            .popper[data-placement^='left'] .popper__arrow {
                                background: ${primary}; !important;
                            }
                            .popper[data-placement^='right'] .popper__arrow {
                                background: ${primary}; !important;
                            }
                        `)));
        }
        return val;
    }
    handleClickOutside(e) {
        const { overlayClickHandler, toggle } = this.props;
        if (e.target.id === 'popover-overlay') {
            e.preventDefault();
            if (overlayClickHandler) {
                overlayClickHandler();
            }
            toggle();
        }
    }
    render() {
        let { placement: desiredPlacement, targetParent } = this.props;
        let { primary, border } = this.props.arrowColors;
        let node = (React.createElement("div", { style: {
                width: '100%',
                height: '100%',
                zIndex: 10,
                position: 'absolute',
                top: 0,
                backgroundColor: 'rgba(0,0,0,0.02)',
            }, id: "popover-overlay" },
            React.createElement("style", { type: "text/css" }, `
                    .popper {                                            
                        background: ${colors_1.white};
                        border: 1px solid ${colors_1.titanium};
                        border-radius: 3px;
                    }
                    
                    .popper .popper__arrow {
                        width: 0;
                        height: 0;
                        border-style: solid;
                        position: absolute;
                        margin: 5px;
                    }
                    
                    .popper[data-placement^='top'] {
                        margin-bottom: 12px;
                    }
                    
                    .popper[data-placement^='top'] .popper__arrow {
                        bottom: -6px;
                        background: ${primary};
                        left: calc(50% - 5px);
                        margin-top: 0;
                        margin-bottom: 0;
                        position: absolute;
                        transform: rotate(45deg);
                        border: 1px solid ${border};
                        width: 10px;
                        height: 10px;
                        border-left: none;
                        border-top: none;
                    }
                    
                    .popper[data-placement^='right'] {
                        margin-left: 12px;
                    }
                    
                    .popper[data-placement^='right'] .popper__arrow {
                        left: -6px;
                        background: ${primary};
                        top: calc(50% - 5px);
                        margin-left: 0;
                        margin-right: 0;
                        position: absolute;
                        transform: rotate(45deg);
                        border: 1px solid ${border};
                        width: 10px;
                        height: 10px;
                        border-right: none;
                        border-top: none;
                    }
                    
                    .popper[data-placement^='left'] {
                        margin-right: 12px;
                    }
                    
                    .popper[data-placement^='left'] .popper__arrow {
                        right: -6px;
                        background: ${primary};
                        top: calc(50% - 5px);
                        margin-left: 0;
                        margin-right: 0;
                        position: absolute;
                        transform: rotate(45deg);
                        border: 1px solid ${border};
                        width: 10px;
                        height: 10px;
                        border-bottom: none;
                        border-left: none;
                    }

                    .popper[data-placement^='bottom'] {
                        margin-top: 12px;
                    }
                    
                    .popper[data-placement^='bottom'] .popper__arrow {
                        top: -6px;
                        background: ${primary};
                        left: calc(50% - 5px);
                        margin-top: 0px;
                        margin-bottom: 0px;
                        position: absolute;
                        transform: rotate(45deg);
                        border: 1px solid ${border};
                        width: 10px;
                        height: 10px;
                        border-right: none;
                        border-bottom: none;
                    }
                    
                `),
            React.createElement(react_popper_1.Popper, { placement: desiredPlacement, modifiers: {
                    preventOverflow: {
                        boundariesElement: 'viewport',
                        padding: 10,
                    },
                } }, ({ ref, style, arrowProps, scheduleUpdate, placement }) => {
                if (!this.scheduleUpdate) {
                    this.scheduleUpdate = scheduleUpdate;
                }
                return (React.createElement("div", { className: "popper", ref: ref, "data-placement": placement, style: Object.assign({}, style), onClick: e => e.stopPropagation() },
                    this.evalChild(),
                    this.props.children,
                    React.createElement("div", { className: "popper__arrow", ref: arrowProps.ref, style: arrowProps.style })));
            })));
        return ReactDOM.createPortal(node, document.getElementById(targetParent));
    }
}
PopoverComponent.defaultProps = {
    placement: 'left',
    arrowColors: {
        primary: colors_1.white,
        secondary: colors_1.white,
        border: colors_1.titanium,
    },
    toggleable: true,
    forceUpdate: false,
};
const Popover = (props) => {
    const ResponsivePopoverContainer = ResponsiveContainer_1.default(props)(PopoverComponent);
    return ResponsivePopoverContainer;
};
exports.default = Popover;
